import {Injectable} from '@angular/core';
import {Dashboard, SearchResult, Summary, AnalysisData, PreviousAnalysis, PreviousAnalysisData, AnalysisKey, AuthLog,
    Logs, AWSResponse} from '../model/analysis-details.model';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { StorageService } from './storage.service';
import {Table} from '../model/small-molecule.model';
import {AuthService} from './auth.service';
import {environment} from '../../environments/environment';
import {catchError, map, tap} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';
import {throwError} from 'rxjs/internal/observable/throwError';

@Injectable({
    providedIn: 'root'
})
export class DBService {
    AnalysisURL: string = environment.serverUrl + '/analysis-data';
    AuthURL: string = environment.serverUrl + '/auth-data';
    ValidationURL: string = environment.serverUrl + '/validate-analysis';
    getUserDataURL: string = environment.serverUrl + '/user-data'

    public searchResults: AnalysisKey[] = [];
    singleSearch = new Subject<SearchResult>();
    authLogs = new Subject<AuthLog[]>();
    userSearch = new Subject<AnalysisKey[]>();

    constructor(private http: HttpClient,
                private storageService: StorageService,
                private authService: AuthService) {
        this.userSearch.subscribe(
            (data: AnalysisKey[]) => {
                this.searchResults = data;
            }
        );
    }

    getAnalysis(type='none', startdate='none', enddate='none') {
        let params = new HttpParams();
        params = params.append('userId', this.storageService.get('username'));
        params = params.append('start', startdate);
        params = params.append('end', enddate);
        params = params.append('type', type);    // type='none' for previous analysis page, type='audit' for audit trail

        this.http.get(this.AnalysisURL, {params: params}).pipe(map(res => <PreviousAnalysisData>res)).subscribe(
            (data) => {
                this.userSearch.next(data.data);
                this.storageService.set('analysis-data', JSON.stringify(data));
            },
            (error) => {
                this.handleError(error);
            }
        );
    }

    getAnalysisDetails(userId, analysisId) {
        // Get a single analysis
        let params = new HttpParams();
        params = params.append('userId', userId);
        params = params.append('analysisId', analysisId);
        params = params.append('type', null);
        params = params.append('path', null);

        this.http.get(this.AnalysisURL, {params: params}).pipe(map(res => <AnalysisData>res)).subscribe(
            (data) => {
                this.singleSearch.next(data.data);
            },
            (error) => {
                this.handleError(error);
            }
        );
    }

    getAuthData(loginId, userId, LogstartDate= 'none', LogendDate= 'none') {
        let params = new HttpParams();
        params = params.append('loginId', loginId);
        params = params.append('userId', userId);
        params = params.append('start_date', LogstartDate);
        params = params.append('end_Date', LogendDate);

        this.http.get(this.AuthURL, {params: params}).pipe(map(res => <AuthLog[]>res)).subscribe(
            (logs) => {
                this.authLogs.next(logs)
                this.storageService.set('login-data', JSON.stringify(logs));
            },
            (error) => {
                this.handleError(error);
            }
        );
    }

    validateAnalysis(analysisKeyObj: AnalysisKey): Observable<AWSResponse> {
        let params = new HttpParams();
        params = params.append('userId', analysisKeyObj.userId);
        params = params.append('group', analysisKeyObj.groupId);
        params = params.append('filename', analysisKeyObj.fileName);
        params = params.append('analysisId', analysisKeyObj.analysisId);
        params = params.append('organization', analysisKeyObj.organizationId);
        params = params.append('analysis_type', analysisKeyObj.analysisType);
        params = params.append('project_code', analysisKeyObj.projectCode_AP);
        return this.http.post<AWSResponse>(this.ValidationURL, {params: params}).pipe(
                tap(),
                catchError(this.handleError)
        );
    }

    getUserData(userId: string): Observable<AWSResponse> {
        let params = new HttpParams();
        params = params.append('userId', userId);
        return this.http.post<AWSResponse>(this.getUserDataURL, {params: params}).pipe(
            tap(),
            catchError(this.handleError)
        );
    }

    private handleError(err: HttpErrorResponse): Observable<never> {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        let errorMessage: string;
        if (err.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            errorMessage = `An error occurred: ${err.error.message}`;
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            errorMessage = `Backend returned code ${err.status}: ${err.message}`;
        }
//         console.error(err);
        return throwError(() => errorMessage);
    }
}
